import type { IconDefinition } from '../index.tsx';

export const iconAlarmClock: IconDefinition = {
  prefix: 'fas',
  iconName: 'iconAlarmClock',
  icon: [
    10,
    10,
    [],
    '',
    'M2.47324 0.910739L0.910739 2.47324L0.0268555 1.58936L1.58936 0.0268555L2.47324 0.910739Z M9.06249 5.31256C9.06249 6.1283 8.82206 6.8879 8.40819 7.52433L9.81696 8.93311L8.93308 9.81699L7.57278 8.4567C6.8722 9.03065 5.97632 9.37506 4.99999 9.37506C4.02368 9.37506 3.1278 9.03066 2.42723 8.45672L1.06696 9.81699L0.183076 8.93311L1.59181 7.52437C1.17793 6.88793 0.937489 6.12832 0.937489 5.31256C0.937489 3.0689 2.75633 1.25006 4.99999 1.25006C7.24365 1.25006 9.06249 3.0689 9.06249 5.31256ZM4.37505 3.12504V5.88392L5.80811 7.31698L6.69199 6.4331L5.62505 5.36615V3.12504H4.37505Z M9.0893 2.47325L7.5268 0.910748L8.41068 0.0268645L9.97318 1.58936L9.0893 2.47325Z',
  ],
  fillRule: 'evenodd',
  clipRule: 'evenodd',
};
